// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609220712/js/" + chunkId + "." + {"44":"6901fb6f","225":"7be928b6","481":"66c47bb6","486":"eac1777e","770":"97765272"}[chunkId] + ".0.3401792963590208.chunk.js";
};